module.exports = __webpack_public_path__ + "img/53_27.f4f2454a.png";